module.exports = __webpack_public_path__ + "static/media/10C.3f21dc0c.png";